import { render, staticRenderFns } from "./ColorPickerButton.vue?vue&type=template&id=57b5931c&scoped=true&"
import script from "./ColorPickerButton.vue?vue&type=script&lang=js&"
export * from "./ColorPickerButton.vue?vue&type=script&lang=js&"
import style0 from "./ColorPickerButton.vue?vue&type=style&index=0&id=57b5931c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b5931c",
  null
  
)

export default component.exports